import React, { Component } from 'react';
import "./RatingCapsuleModal.css";
import Rater from 'react-rater'
import 'react-rater/lib/react-rater.css'

class RatingCapsuleModal extends Component {
    constructor(props) {
        super(props);
        this.state = { rating: 0, commentaire: '', currentRate: 0, firstRate: this.props.firstRate };
    }

    addRatingCaps = (rating) => {
        const { uid } = this.state;
        if (this.props.firstRate) {
            this.setState({ firstRate: rating, user: uid });
        } else {
            this.setState({ rating: rating, user: uid });
        }
    }

    validateRate = () => {
        const { rating, firstRate, commentaire } = this.state;
        let currentRate = rating;
        if (rating === 0 && firstRate) {
            currentRate = firstRate
        }
        if (commentaire && commentaire.trim().length > 0) {
            this.props.addRating(currentRate, commentaire)
        } else {
            this.props.addRating(currentRate, "")
        }
        this.props.onClose();
    }

    onChange = event => {
        if (event.target.value.length > 0) {
            this.setState({ commentaire: event.target.value });
        }
    }

    render() {
        return (
            <div className="p-4">
                <h1 className="title-rating mt-5">Notez votre satisfaction quant à la réalisation de la capsule.</h1>

                {
                    this.props.firstRate ? <div hidden={false} className="mb-cust text-center start-size justify-content-center d-flex mt-4">
                        <Rater onRate={({ rating }) => { this.addRatingCaps(rating) }} rating={this.state.firstRate} total={5} interactive={true} />
                        <h1 className="rating-custom">{this.props.firstRate}/5</h1>
                    </div> : <div hidden={true} className="mb-cust text-center start-size justify-content-center d-flex mt-4">
                            <Rater onRate={({ rating }) => { this.addRatingCaps(rating) }} rating={this.state.rating} total={5} interactive={true} />
                            <h1 className="rating-custom">{this.state.rating}/5</h1>
                        </div>
                }
                <div className="callback-experience-container">
                    <h1 className="rating-commentaire">Commentaire</h1>
                    <textarea name="commentaire" className="text-area-rating" placeholder="Laisser un commentaire (facultatif)" rows="3" onChange={this.onChange} />
                </div>
                <div className="text-right">
                    <button onClick={this.validateRate} className="button-rating cursor-pointer">OK</button>
                </div>
            </div>
        )
    }
}

export default RatingCapsuleModal;